/**
 * Textos da tela "Conferir laudo e orientações" (E159.F3, GUS-153, ADR-0109 §2.7). O trecho, o
 * que o documento diz, o que a fonte diz e o detalhe de cada critério vêm do servidor; aqui ficam
 * os rótulos, as situações e o que cada saída precisa. E168.F8: a aprovação é da conferência por
 * regras e não é a revisão do perito, que é registrada na mesa.
 */
export const ptBRSaidas = {
  sobretitulo: 'Trabalho / Equipe',
  titulo: 'Conferir laudo e orientações',
  subtitulo:
    'O texto de cada saída é conferido com o resultado, o cadastro e a leitura dos documentos. Corrija os apontamentos na fonte e confira de novo antes de assinar e entregar.',
  voltar: 'Voltar ao resultado',
  carregando: 'Carregando a conferência…',
  tentarDeNovo: 'Tentar de novo',
  conferirAgora: 'Conferir agora',
  conferindo: 'Conferindo…',
  conferirAgoraAjuda:
    'Gera o laudo e as orientações da rodada vigente e confere os dois. A equipe continua pré-visualizando: a conferência trava só a assinatura e a entrega.',
  // E170.F2.C05 (GUS-229, reteste 3): sem o botão enquanto um passo anterior segura a conferência.
  conferirDepois: 'A conferência fica disponível depois de: {acao}.',
  saidasDaVersao: 'Saídas da mesma versão',
  rodadaVigente: 'Rodada vigente: {rodada}.',
  semResultado: 'O caso ainda não tem resultado avaliado para conferir.',
  naoAplicavel:
    'A conferência das saídas é do exame eletrônico. O laudo grafotécnico segue a revisão do perito.',
  limiteTitulo: 'O que a conferência julga',
  aviso: {
    corrigir:
      'Há apontamentos a corrigir. A assinatura e a entrega ficam travadas até a saída ser conferida e aprovada.',
    conferir: 'Confira as saídas desta rodada antes de assinar e entregar.',
    pronto:
      'As saídas desta rodada passaram na conferência por regras. A revisão do perito é registrada na mesa: esta conferência não a substitui.',
  },
  saida: {
    laudo: {
      nome: 'Laudo para o processo',
      descricao:
        'Conferência por regras, sem revisão humana. Revisão e assinatura do perito obrigatórias antes da entrega.',
    },
    riscos: {
      nome: 'Orientações para o jurídico',
      descricao: 'Saída reservada, conferida separadamente. É liberada junto com o laudo assinado.',
    },
  },
  situacao: {
    conferida: 'Conferida na rodada vigente',
    desatualizada: 'Conferida numa rodada anterior',
    nao_conferida: 'Ainda não conferida',
  },
  estado: {
    // E168.F8.C01 (QA de 24/10): aprovação das regras não é prontidão para assinar.
    aprovado: 'Regras aprovadas',
    corrigir: 'Corrigir',
    bloqueado: 'Bloqueada',
  },
  pendencia: {
    conferir: 'Confira esta saída na rodada vigente.',
    corrigir: 'Corrija os apontamentos na fonte e confira de novo.',
    revisar:
      'Pronta para a revisão do perito. A assinatura espera o material que falta para a conclusão.',
    assinar: 'Pronta para a assinatura do laudo.',
    liberar: 'O laudo foi assinado. Libere as orientações.',
    nenhuma: 'Nada pendente nesta saída.',
  },
  artefato: '{etapa} · versão {versao} · rodada {rodada} · {data}',
  etapa: { rascunho: 'Rascunho', final: 'Final' },
  motivoDaSaida: 'Esta saída não foi gerada agora: {motivo}',
  apontamentos: 'Apontamentos',
  semApontamentos: 'Nenhum apontamento nesta conferência.',
  apontamento: {
    gravidade: { bloqueado: 'Trava a assinatura', corrigir: 'A corrigir' },
    trecho: 'Trecho do documento',
    semTrecho: 'O documento não traz o que deveria.',
    noDocumento: 'O documento diz',
    naFonte: 'A fonte diz',
    fonte: 'Fonte',
    ondeCorrigir: {
      rever_na_fonte: 'Rever na fonte',
      revisar_na_mesa: 'Revisar na mesa',
      cadastro_do_caso: 'Corrigir o cadastro do caso',
      composicao:
        'Correção técnica do documento: a saída fica travada até a correção. Avise o suporte.',
    },
  },
  criterios: 'Ver os critérios conferidos ({total})',
  grupo: {
    campos: 'Campos confrontados',
    afirmacoes: 'Afirmações decisivas',
    protecao: 'Proteção',
  },
  estadoDoCriterio: {
    passou: 'Passou',
    falhou: 'Falhou',
    inconclusivo: 'Inconclusivo',
    nao_se_aplica_justificado: 'Não se aplica',
  },
  criterio: {
    identidade_do_caso: 'Identidade do caso',
    modo_do_exame: 'Modo do exame',
    versao_do_resultado: 'Versão do resultado',
    conclusao: 'Conclusão',
    matriz_publica: 'Matriz dos requisitos',
    essencial_no_laudo: 'Fatos essenciais no laudo',
    riscos_do_reservado: 'Riscos das orientações',
    respostas_dos_riscos: 'Respostas e graus dos riscos',
    parte_e_cpf: 'Parte e CPF',
    ficha_confere: 'Dados lidos dos documentos',
    ausencia_contradita: 'Ausência contradita pela leitura',
    conclusao_registrada: 'Conclusão registrada contra o exame',
    coerencia_da_conclusao: 'Coerência da conclusão',
    decisao_refeita: 'Conclusão regular com prova da pessoa e do ato',
    conclusao_na_parte: 'Redação da conclusão: termos, dados cortados e descrição das provas',
    resultado_unico: 'Um só resultado no documento, sem requisito à espera de revisão',
    contagem_dos_requisitos: 'Contagem dos requisitos',
    contagem_da_integridade: 'Contagem da integridade com as limitações da seção 2',
    papeis_coerentes: 'Instituição, escritório e operador',
    vigencia_dos_dispositivos: 'Vigência das normas citadas',
    remissao_resolvida: 'Remissões internas',
    teste_executado: 'Teste ou verificação afirmada',
    consulta_executada: 'Consulta afirmada',
    carimbo_e_cadeia: 'Carimbo do tempo e cadeia',
    presenca_fisica: 'Presença física',
    posse_do_original: 'Posse do original',
    autoria: 'Autoria',
    instante_presumido: 'Horário com fuso presumido',
    validade_ou_fraude: 'Validade ou fraude',
    revisao_registrada: 'Revisão do perito registrada',
    vocabulario_publico: 'Vocabulário público',
    cpf_completo: 'CPF completo',
    marcador_de_preenchimento: 'Marcador de preenchimento',
    reservado_fora_do_laudo: 'Conteúdo reservado no laudo',
    aviso_do_reservado: 'Aviso de uso interno',
    endereco_do_caso: 'Endereço de outro caso',
    legivel_no_pdf: 'Legível no PDF',
    grau_sem_marca: 'Grau dos traços faciais sem marca interna',
    diligencia_registrada: 'Diligência feita no exame não vira risco de ausência',
    marca_do_laudo: 'Marca "também no laudo" pelo texto do exame',
    resposta_pela_prova: 'Resposta técnica com a prova do exame',
    providencia_especifica: 'Providência própria de cada risco',
    sem_identificador_interno: 'Sem identificador interno no texto',
  },
  bloqueante: 'trava',
  erro: {
    sem_permissao: 'A conferência das saídas é da equipe do caso.',
    nao_encontrado: 'Caso não encontrado.',
    nao_aplicavel: 'A conferência das saídas é do exame eletrônico.',
    laudo_nao_pronto:
      'O laudo ainda não pode ser gerado: siga o "Próximo passo" no alto desta tela e confira de novo.',
    desatualizado: 'O resultado mudou enquanto a conferência rodava. Confira de novo.',
    indisponiveis: 'As orientações não puderam ser geradas nesta rodada.',
    falha_do_documento: 'Não foi possível gerar o documento para conferir. Tente de novo.',
    indisponivel: 'Não foi possível carregar a conferência agora.',
  },
  linkParaAConferencia: 'Conferir laudo e orientações',
};
